/**
 * @ngdoc Controller
 * @name EconomicController
 */
import { handleFileDownload } from "@/utils/download";

(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('EconomicController', EconomicController);

    /**
     * @constructor
     * @ngInject
     */
    function EconomicController($log, $timeout, locale, $scope, $stateParams, $state, $q, ApiService, InstallationsService, GraphService, $location, VrmModalService, vrmNotificationsService, vrmNotificationType, economicGraph, fuelUsageGraph) {
        $log.info('EconomicController');


        $scope.hasGrid = false;
        $scope.hasGenset = false;

        var calc_offset = 0;

        $scope.picker = {
            maxDate: new Date(),
            minDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime(),
            till: new Date().getTime()
        };

        $scope.loading = true;

        locale.ready('common', 'core','datepicker').then(function () {
            $scope.pickadata = {
                dateOptions: {
                    clear: false,

                    monthsFull: [
                        locale.getString('datepicker.january'),
                        locale.getString('datepicker.februari'),
                        locale.getString('datepicker.march'),
                        locale.getString('datepicker.april'),
                        locale.getString('datepicker.may'),
                        locale.getString('datepicker.juni'),
                        locale.getString('datepicker.july'),
                        locale.getString('datepicker.august'),
                        locale.getString('datepicker.september'),
                        locale.getString('datepicker.october'),
                        locale.getString('datepicker.november'),
                        locale.getString('datepicker.december')
                    ],
                    weekdaysShort: [
                        locale.getString('datepicker.short_sunday'),
                        locale.getString('datepicker.short_monday'),
                        locale.getString('datepicker.short_tuesday'),
                        locale.getString('datepicker.short_wednesday'),
                        locale.getString('datepicker.short_thursday'),
                        locale.getString('datepicker.short_friday'),
                        locale.getString('datepicker.short_saturday')
                    ],
                    today: locale.getString('datepicker.today'),
                    close: locale.getString('datepicker.close'),
                    format: locale.getString('datepicker.format')
                },
                timeOptions: {
                    clear: false,
                    format: 'HH:i'
                }
            };

            $scope.inputs = locale.getString('core.loading');

            $scope.currencies = [
                { name: locale.getString('common.euro'), sign: '€', code: 'EUR', maxValue: '5'},
                { name: locale.getString('common.dollar'), sign: '$', code: 'USD', maxValue: '5' },
                { name: locale.getString('common.pound'), sign: '£', code: 'GBP', maxValue: '5' },
                { name: locale.getString('common.rand'), sign: 'R', code: 'ZAR', maxValue: '25' }
            ];

            // Models for the economic controls
            $scope.economic = {
                scenarios: ['genset', 'grid'],
                scenario: $stateParams.scenario || 'grid',
                solar_maintenance_costs: +$stateParams.solar_maintenance_costs || 0,
                genset_maintenance_costs: +$stateParams.genset_maintenance_costs || 0,
                grid_kwh_price: +$stateParams.grid_kwh_price || 0.20,
                grid_kwh_sell_price: +$stateParams.grid_kwh_sell_price || 0.20,
                fuel_litre_price: +$stateParams.fuel_litre_price || 1.50,
                genset_size_kva: +$stateParams.genset_size_kva || 500,
                currency: findCurrency($stateParams.currency)
            };

            $scope.genset_maintenance_costs = $scope.economic.genset_maintenance_costs;
            $scope.grid_kwh_sell_price = $scope.economic.grid_kwh_sell_price;
            $scope.fuel_litre_price = $scope.economic.fuel_litre_price;
            $scope.solar_maintenance_costs = $scope.economic.solar_maintenance_costs;
            $scope.grid_kwh_price = $scope.economic.grid_kwh_price;
            $scope.genset_size_kva = $scope.economic.genset_size_kva;

            $scope.updateEconomicValues = function (field) {
                if ($scope[field] === "null") {
                    $scope[field] = 0;
                    $scope.economic[field] = 0;
                }
                $scope.economic[field] = $scope[field];
            };
            
            function getScenarioParameters() {
                return {
                    scenario: $scope.economic.scenario,
                    start: $scope.getRange().from,
                    end: $scope.getRange().to,
                    interval: $scope.getInterval() || 'days',
                    solar_maintenance_costs: $scope.economic.solar_maintenance_costs,
                    genset_maintenance_costs: $scope.economic.genset_maintenance_costs,
                    grid_kwh_price: $scope.economic.grid_kwh_price,
                    grid_kwh_sell_price: $scope.economic.grid_kwh_sell_price,
                    fuel_litre_price: $scope.economic.fuel_litre_price,
                    genset_size_kva: $scope.economic.genset_size_kva,
                    currency: $scope.economic.currency.code,
                };
            }

            function dateFromTimestamp(timestampInInstallationTimezone) {
                var timestampInUtc = timestampInInstallationTimezone + calc_offset;
                var res = new Date(timestampInUtc).getTime() + (new Date().getTimezoneOffset() * 60000);
                return res;
            }
            function findCurrency(code) {
                if (code) {
                    return _.find($scope.currencies, function(currency) {
                        return currency.code === code;
                    });
                }
                return $scope.currencies[0];
            }

            $scope.setScenario = function (scenario) {
                $scope.economic.scenario = scenario;

                // Select another tab ('table') when 'fuel_usage' is being hidden
                if ($scope.activeTab ==='fuel_usage' && !($scope.hasGenset || $scope.economic.scenario === 'genset')) {
                    $scope.activeTab = 'table';
                }
            };

            $scope.tabs = ['table', 'graph'];
            $scope.activeTab = 'table';

            $scope.setActiveTab = function (tab) {
                $scope.activeTab = tab;
            };

            InstallationsService.getInstallation($stateParams.id).then(function(installation) {
                if (!installation) return;
                calc_offset = installation.timezone_offset * 1000;

                $scope.picker = {
                    maxDate: new Date(),
                    minDate: new Date(new Date().setDate(new Date().getDate()-5*365)),
                    from: $stateParams.start ? dateFromTimestamp($stateParams.start * 1000): new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime(),
                    till: $stateParams.end ? dateFromTimestamp($stateParams.end * 1000): new Date().getTime()
                };

                $scope.installation = installation;

                // Check if the installation has Grid or Generator AC inputs by checking the si1/si2 data attributes.
                $scope.hasGrid = (installation.data.si1 && installation.data.si1.rawValue == '1') || (installation.data.si2 && installation.data.si2.rawValue == '1');
                $scope.hasGenset = (installation.data.si1 && installation.data.si1.rawValue == '2') || (installation.data.si2 && installation.data.si2.rawValue == '2');

                // Bind the textValue of the AC Inputs to $scope for displaying
                $scope.inputs = [];
                if (installation.data.si1 && installation.data.si1.textValue && installation.data.si1.rawValue)
                {
                    $scope.inputs.push(installation.data.si1.textValue);
                }
                if (installation.data.si2 && installation.data.si2.textValue && installation.data.si2.rawValue > 0)
                {
                    $scope.inputs.push(installation.data.si2.textValue);
                }
                $scope.inputs = $scope.inputs.join(' and ');
                $scope.$evalAsync();
                ApiService
                    .call('/installations/' + $stateParams.id + '/economic-meta', null, 'GET', false, 'json', false)
                    .then(function(response) {
                        $scope.economicMeta = response.data.records;

                        // Use the value from the API to check if the generator was used during the past 6 months
                        $scope.hasGenset = $scope.economicMeta.has_used_genset;
                        // Set the min date to the min timestamp that is in the database
                        $scope.picker.minDate = new Date($scope.economicMeta.min_timestamp * 1000);

                        // Set the default generator size acccording to the data fetched from the API when there is no URL param defining it.
                        $scope.economic.genset_size_kva = +$stateParams.genset_size_kva || ($scope.economicMeta.estimated_generator_size > 500 ? 500 : $scope.economicMeta.estimated_generator_size);
                        $scope.gensetSizeKva = $scope.economic.genset_size_kva;
                        // Load graph data only for the results page;
                        if ($state.current.name === 'base.installation.reporting.economic-result') {
                            GraphService.ready().then(function () {
                                GraphService.highcharts.setOptions({
                                    global: {
                                        currencySign: $scope.economic.currency.sign,
                                        timezoneOffset: -$scope.installation.timezone_offset / 60
                                    }
                                });

                                var config = economicGraph();

                                var arrActual = [];
                                if ($scope.hasGrid || $scope.economic.scenario === 'grid')
                                {
                                    arrActual.push(0);// from grid
                                    arrActual.push(1);// to grid
                                    arrActual.push(3);// solar
                                }
                                if ($scope.hasGenset || $scope.economic.scenario === 'genset' )
                                {
                                    arrActual.push(2);//Fuel cost
                                    arrActual.push(4);//Genset maintenance
                                }
                                var arrTotal = [5, 6];// Comparison running costs && Compariso maintenance
                                config.options.tooltip.formatter = GraphService.getTooltipFormatterWithMultipleTotals(['graph.actual_total', 'graph.scenario_total_'+$scope.economic.scenario], [arrActual, arrTotal]).formatter;
                                $scope.graph = config;
                                $scope.fuelUsageGraph = fuelUsageGraph();

                                // Load the initial data;
                                reloadData();

                                // A list of properties that triggers data reloading on change.
                                $scope.$watch('economic', reloadData, true);
                                $scope.$watch('picker', reloadData, true);
                            });
                        }
                    });
            });

            var downloadPending = false;
            $scope.downloadSheet = function (format) {
                var scenarioParameters = getScenarioParameters();
                scenarioParameters.download = format;

                // Check if we are already downloading data
                if (downloadPending) {
                    locale.ready('advanced').then(function () {
                        vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('advanced.download_pending') });
                    });
                    return;
                }

                downloadPending = true;
                ApiService.installationDownload($scope.installation.id, 'economic', scenarioParameters,false).then(function(response) {
                    handleFileDownload(response.data, "economic-report." + format);
                    downloadPending = false;
                }, function() {
                    locale.ready('advanced').then(function () {
                        vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('advanced.download_timeout') , timeout: 30000});
                    });
                        downloadPending = false;
                });
           };

            // Go to /economic-result and update the URL Query params for easy sharing.
            $scope.generateScenario = function () {
                if ($state.current.name === 'base.installation.reporting.economic-result') {
                    return;
                }
                else {
                    $state.go('base.installation.reporting.economic-result', getScenarioParameters());
                }
            };

            $scope.openModal = function() {
                VrmModalService.openReportTemplateModal($scope, function(arg) {
                    if(!arg) {
                        vrmNotificationsService.add({type: vrmNotificationType.ERROR, message: locale.getString('reporting.template_name_required')});
                    } else {
                        var data = getScenarioParameters();
                        data.report_type = 'economic';
                        data.idSite = $stateParams.id;
                        data.name = arg;

                        ApiService.reportTemplates($scope.installation.id, null, data, 'POST').then( response => {
                            if(response.data.errors){
                                switch(response.data.errors.name){
                                    case 'This value is too short. It should have 2 characters or more.':
                                        locale.ready('reporting').then(
                                            vrmNotificationsService.add({
                                            type: vrmNotificationType.ERROR,
                                            message: locale.getString('reporting.invalid_template_name')
                                        }));
                                        break
                                    case 'reporttemplate.name.must.be.unique.for.installation':
                                        locale.ready('reporting').then(
                                            vrmNotificationsService.add({
                                            type: vrmNotificationType.ERROR,
                                            message: locale.getString('reporting.unique_report_template_name')
                                        }));
                                        break
                                    default:
                                        vrmNotificationsService.add({
                                            type: vrmNotificationType.ERROR,
                                            message: ApiService.formatErrors(response)
                                        });
                                }
                            }
                            else{
                                vrmNotificationsService.add({type: vrmNotificationType.SUCCESS, message: locale.getString('reporting.template_saved')});
                            }
                        });
                    }
                });
            };

            // Only do a data reload every 300 ms, to prevent multiple loads
            var dataReloadTimeout = null;
            function reloadData() {
                $timeout.cancel(dataReloadTimeout);
                dataReloadTimeout = $timeout(function () {
                    $scope.generateScenario();
                    if ($scope.activeTab === 'graph') {
                        $scope.graph.loading = true;
                        resetZoomState($scope.graph);
                    }

                    if ($scope.activeTab === 'fuel_usage') {
                        $scope.fuelUsageGraph.loading = true;
                        resetZoomState($scope.fuelUsageGraph);
                    }

                    loadData();
                }, 300);
            }

            function toUTC(date) {
                return date - (date.getTimezoneOffset() * 60000);
            }

            $scope.getRange = function() {

                if (!$scope.picker.from || !$scope.picker.till)
                    return false;
                var from, to;
                if (typeof $scope.picker.from !== "object")
                    from = new Date($scope.picker.from);
                else
                    from = new Date($scope.picker.from.valueOf());
                if (typeof $scope.picker.till !== "object")
                    to = new Date($scope.picker.till);
                else
                    to = new Date($scope.picker.till.valueOf());

                from.setHours(0);
                from.setMinutes(0);
                from.setSeconds(0);
                from.setMilliseconds(0);
                to.setHours(23);
                to.setMinutes(59);
                to.setSeconds(59);
                to.setMilliseconds(0);
                var fromInTimezone = (toUTC(from) - calc_offset) / 1000;
                var toInTimezone = (toUTC(to) - calc_offset) / 1000;
                return {
                    from: fromInTimezone,
                    to: toInTimezone
                }
            };

            $scope.getInterval = function() {
                var interval  = 'hours';
                var range = $scope.getRange();
                var from = range.from;
                var till = range.to;
                var diff = (till - from);
                interval = diff > 86400 ? 'days' : interval;
                interval = diff > 86400 * 21 ? 'weeks' : interval;
                interval = diff > 86400 * 30 * 3 ? 'months' : interval;
                interval = diff > 86400 * 30 * 12 * 3 ? 'years' : interval;
                return interval;
            };

            function loadData() {
                if (!$scope.installation) {
                    return;
                }
                var range = $scope.getRange();

                if (!range) return;

                var interval = $scope.getInterval() || 'days';

                var isEconomicScenario = true;
                var scenario = isEconomicScenario ? $scope.economic.scenario : null;
                var solar_maintenance_costs = isEconomicScenario ? $scope.economic.solar_maintenance_costs : null;
                var grid_kwh_price = isEconomicScenario ? $scope.economic.grid_kwh_price : null;
                var grid_kwh_sell_price = isEconomicScenario ? $scope.economic.grid_kwh_sell_price : null;
                var genset_maintenance_costs = isEconomicScenario ? $scope.economic.genset_maintenance_costs : null;
                var fuel_litre_price = isEconomicScenario ? $scope.economic.fuel_litre_price : null;
                var genset_size_kva = isEconomicScenario ? $scope.economic.genset_size_kva : null;

                // Collect all parameters, the null ones are not url encoded.
                var parameters = {
                    scenario: scenario,
                    solar_maintenance_costs: solar_maintenance_costs,
                    genset_maintenance_costs: genset_maintenance_costs,
                    fuel_litre_price: fuel_litre_price,
                    grid_kwh_price: grid_kwh_price,
                    grid_kwh_sell_price : grid_kwh_sell_price,
                    genset_size_kva: genset_size_kva
                };

                var dataURL = 'economic';

                GraphService.getGraphData($stateParams.id, range.from, range.to, interval, dataURL, parameters).then(function (data) {
                    $scope.economicData = data;
                    $scope.graph.series[0].data = emptyOnNull(data.records.grid);  // Actual grid cost
                    $scope.graph.series[1].data = emptyOnNull(data.records.to_grid); // Actual grid sell cost
                    $scope.graph.series[2].data = emptyOnNull(data.records.genset); // Actual genset cost
                    $scope.graph.series[3].data = emptyOnNull(data.records.actual_solar_maintenance); // Actual solar maintenance costs
                    $scope.graph.series[4].data = emptyOnNull(data.records.actual_genset_maintenance); // Actual genset maintenance costs
                    $scope.graph.series[5].data = emptyOnNull(data.records.compare); // Comparison scenario costs
                    $scope.graph.series[6].data = emptyOnNull(data.records.compare_maintenance); // Comparison scenario maintenance costs

                    // Load the fuel usage profile graph data;
                    var fuelUsageProfile = data.records.fuel_usage_profile;
                    var fuelUsageGraphData = _.values(_.mapValues(fuelUsageProfile, function(value, key) { return [+key, value]; }));
                    $scope.fuelUsageGraph.series[0].data = emptyOnNull(fuelUsageGraphData);

                    $scope.economicTotals = data.totals;
                    $scope.economicTotals.actual = data.totals.grid + data.totals.genset;
                    $scope.economicTotals.actual_maintenance = data.totals.actual_solar_maintenance + data.totals.actual_genset_maintenance;
                    $scope.economicTotals.total_actual = $scope.economicTotals.actual + $scope.economicTotals.actual_maintenance;
                    $scope.economicTotals.total_scenario = data.totals.compare + data.totals.compare_maintenance;

                }).catch(function () {
                    $scope.graph.series[0].data = [];
                    $scope.graph.series[1].data = [];
                    $scope.graph.series[2].data = [];
                    $scope.graph.series[3].data = [];
                    $scope.graph.series[4].data = [];
                    $scope.graph.series[5].data = [];
                    $scope.graph.series[6].data = [];

                    $scope.fuelUsageGraph.series[0].data = [];
                    $scope.loading = false;
                }).then(function () {
                    $scope.graph.series[0].visible = true;
                    $scope.graph.series[1].visible = true;
                    $scope.graph.series[2].visible = true;
                    $scope.graph.series[3].visible = true;
                    $scope.graph.series[4].visible = true;
                    $scope.graph.series[5].visible = true;
                    $scope.graph.series[6].visible = true;
                    $scope.fuelUsageGraph.series[0].visible = true;
                    $scope.graph.loading = false;
                    $scope.fuelUsageGraph.loading = false;
                    $scope.loading = false;
                    updateColspanValues();
                    updateTableTimestringFormat();
                });
            }

            function updateColspanValues() {
                $scope.actualColspanValue = $scope.hasGrid ? 6 : 2;
                $scope.actualColspanValue += $scope.hasGenset ? 4 : 0;
            }

            function updateTableTimestringFormat() {
                switch ($scope.getInterval()) {
                    case 'years':
                        $scope.tableTimeString = 'y';
                        break;
                    case 'months':
                        $scope.tableTimeString = 'MMM, y';
                        break;
                    case 'weeks':
                        $scope.tableTimeString = 'MMM d, y';
                        break;
                    case 'hours':
                        $scope.tableTimeString = 'HH:mm';
                        break;
                    default:
                        $scope.tableTimeString = 'MMM d, y';
                        break;
                }
            }

            $scope.$on('$destroy', function () {
                $timeout.cancel(dataReloadTimeout);
            });


            // Convert null dataset to empty dataset
            function emptyOnNull(data) {
                data = data ? data : [];
                // Highcharts requires sorted X values
                data = _.sortBy(data, function (data) { return data[0]; });
                return data;
            }

            // Helper function for reseting the zoom of a chart.
            function resetZoomState(targetChart) {
                if (targetChart && targetChart.getHighcharts) { // It is null while updating
                    var chart = targetChart.getHighcharts();
                    chart.zoomOut();
                }
                else if (targetChart) {
                    // Small hack to wait until getHighCharts() becomes available
                    _.defer(_.once(function () {
                        resetZoomState(targetChart);
                    }));
                }
            }
        });
    }
})();
